/**
 * OneTrust cookie service
 * @link https://www.onetrust.com/products/cookie-consent/
 */
export const OneTrustService: IOneTrustService = {
	// OnetrustActiveGroups: ',C0001,C0002,C0003,C0004,',
	ToggleInfoDisplay: (): any => {
		const _w = window as any;
		if (Object.prototype.hasOwnProperty.call(_w, 'OneTrust')) {
			if (Object.prototype.hasOwnProperty.call(_w.OneTrust, 'ToggleInfoDisplay')) {
				_w.OneTrust.ToggleInfoDisplay();
			}
		}
	},

	OnConsentChanged: (e: any): any => {
		//return e;
		throw new Error('Implement/override me in the component');
	},

	// hasGivenConsent(consentLevel: 'C0001'|'C0002'|'C0003'|'C0004'): boolean {
	// 	let data: string[] = [];
	// 	if ((window as any).OnetrustActiveGroups) {
	// 		data = (window as any).OnetrustActiveGroups.split(',');
	// 	}
	// 	return consentLevel in data;
	// }
	hasGivenConsent(): boolean {
		let data: string[] = [];
		const _w = window as any;
		if (_w && _w.OnetrustActiveGroups) {
			data = _w.OnetrustActiveGroups.split(',');
		}
		return data.indexOf('C0004') > -1;
	},

	GetDomainData(): OneTrustDomainData {
		const data = [
			{
				"OptanonGroupId": "C0002",
				"PurposeId": "XXXXXXXX-34B8-4A75-89D8-7BB3216F59D5",
				"CustomGroupId": "C0002",
				"GroupId": "6c8a0b3c-4084-463d-a1ca-7734ce435047",
				"Status": "inactive",
			},
			{
				"OptanonGroupId": "C0003",
				"PurposeId": "XXXXXXXX-3A04-4FE7-8398-DBCB703A0DFB",
				"CustomGroupId": "C0003",
				"GroupId": "486a5448-5ed1-41b9-928b-451ca2aa7d16",
				"Status": "inactive",
			},
			{
				"OptanonGroupId": "C0005",
				"PurposeId": "XXXXXXXX-B3C5-4331-B2A0-C43D713C9DD4",
				"CustomGroupId": "C0005",
				"GroupId": "ca46bf1f-69c9-4e9d-bb94-d5913e6bdaf5",
				"Status": "inactive",
			},
			{
				"OptanonGroupId": "C0004",
				"PurposeId": "XXXXXXXX-3A0E-40CE-9793-8C316662E14D",
				"CustomGroupId": "C0004",
				"GroupId": "63fc57e8-4c97-4828-a9c6-bf0cb5e66c85",
				"Status": "inactive",
			},
			{
				"OptanonGroupId": "C0001",
				"PurposeId": "XXXXXXXX-44DA-405C-91B8-485C58EA9165",
				"CustomGroupId": "C0001",
				"GroupId": "db8b7d34-8503-48ac-9cd5-2dba23c138c1",
				"Status": "always active",
			}
		];
		return {
			Groups: data,
		};
	},
	setConsentProfile(options: ContentProfileOptions): void {
		const _w = window as any;
		if (options && options.purposes && options.purposes.length > 0) {
			if (Object.prototype.hasOwnProperty.call(_w, 'OneTrust')) {
				if (Object.prototype.hasOwnProperty.call(_w.OneTrust, 'UpdateConsent')) {
					// call one trust hook for enabling consent for cookie category C0004
					_w.OneTrust.UpdateConsent("Category", "C0004:1");
				}
			}
		}
	}
};

interface OneTrustGroups {
	/** The group ID, like "C0002" */
	CustomGroupId: string;
	/** like "C0DFCC30-34B8-4A75-89D8-7BB3216F59D5" */
	PurposeId: string;
	// ...loads more props here
}
export interface OneTrustDomainData {
	Groups: OneTrustGroups[];
	// ...
}
interface ContentProfileOptions {
	purposes: {
		Id: string;
		TransactionType: 'CONFIRMED'; // or others
	}[];
}
// to see the one trust API in the window, just open a live website and in the console type:
// OneTrust.
// and you will see the methods/props available
// The below is just for Storybook so components can call external OneTrust window methods, which exist in on live but not on local
export interface IOneTrustService {
	// OnetrustActiveGroups: string;
	ToggleInfoDisplay: () => any;
	OnConsentChanged: (e: any) => any;
	hasGivenConsent: () => any;
	GetDomainData: () => OneTrustDomainData | undefined;
	setConsentProfile: (options: ContentProfileOptions) => any;
	// ...
}
